import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SerialNoCellComponent } from '../../table-cell/serial-no-cell.component';
import { MasterSearchTransmissionService } from '../../services/raintree/Transmission/master-search.service';
import { GlobalRespo, GlobalResponseData } from '../../services/raintree/interfaces/global-respo';
import { DpTableComponent } from "../../common-component/dp-table/dp-table.component";
import { StatusCellComponent } from '../../table-cell/status-cell.component';

@Component({
    selector: 'are-you-updated-dialog',
    standalone: true,
    templateUrl: './are-you-updated-dialog.component.html',
    styleUrl: './are-you-updated-dialog.component.scss',
    imports: [CommonModule, ReactiveFormsModule, DpTableComponent, FormsModule, MatDialogModule]
})
export class AreYouUpdatedDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
  public displayColumnData: any = [
    {
      id: 'mk',
      name: 'Serial No.',
    },
    {
      id: 'philName',
      name: 'Name',
    },
    {
      id: 'rs',
      name: 'Status',
    },
    {
      id: 'st',
      name: 'State',
    },
    {
      id: 'dn',
      name: 'District',
    },
    {
      id: 'lastIvDate',
      name: 'Last Istavrity Date',
    },
  ];

  cellComponentMap = {
    mk: SerialNoCellComponent,
    rs: StatusCellComponent
  };
}
